import React from '../services/React';
import ErrorMessage from './ErrorMessage';

function AuthErrorMessage() {
  return (
    <ErrorMessage
      title="Unexpected error"
      message="There was an unexpected error. Please reload the app."
    />
  );
}

export default AuthErrorMessage;



// WEBPACK FOOTER //
// ./src/commons/components/UnexpectedErrorMessage.jsx